import { IconProps } from '.';
const LocationIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClasses}
      {...rest}
    >
      <g id="at-icon-location-40">
        <path
          id="Vector"
          d="M29.4256 26.0945L19.9974 35.5225L10.5693 26.0945C5.36231 20.8875 5.36231 12.4452 10.5693 7.23826C15.7763 2.03126 24.2186 2.03126 29.4256 7.23826C34.6324 12.4452 34.6324 20.8875 29.4256 26.0945Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default LocationIcon;
